import { Card, Flex, Typography } from "antd";
import type { ReactNode } from "react";
import { useI18n } from "@/i18n";
import { LanguageSwitch } from "./LanguageSwitch";
import { Wordmark } from "./Logo";

/** Centered card used by every signed-out screen; `aside` sits beside it on wide screens and below it on phones. */
export function AuthLayout({ title, subtitle, aside, children }: { title: string; subtitle?: ReactNode; aside?: ReactNode; children: ReactNode }) {
  const { t } = useI18n();
  return (
    <main style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Flex justify="space-between" align="center" style={{ padding: "20px 32px" }}>
        <Wordmark size={30} />
        <LanguageSwitch />
      </Flex>
      <Flex flex={1} justify="center" align="center" wrap gap={32} style={{ padding: "24px 16px 64px" }}>
        <Card style={{ width: "100%", maxWidth: 440 }} styles={{ body: { padding: 32 } }}>
          <Typography.Title level={2} style={{ marginTop: 0, marginBottom: subtitle ? 8 : 24, fontSize: 24 }}>
            {title}
          </Typography.Title>
          {subtitle && (
            <Typography.Paragraph type="secondary" style={{ marginBottom: 24 }}>
              {subtitle}
            </Typography.Paragraph>
          )}
          {children}
        </Card>
        {aside}
      </Flex>
      <Typography.Text type="secondary" style={{ textAlign: "center", paddingBottom: 24, fontSize: 12 }}>
        {t("app.tagline")}
      </Typography.Text>
    </main>
  );
}
